module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/2-2751fc91deaf201c07b67223bd566412.jpg";